import { UPDropdownItem } from 'components/dropdown';
import { toNumber } from 'lodash';
import IEmployeeFunctionLink from 'types/company/payroll/IEmployeeFunctionLink';
import IPayrollFunction from 'types/company/payroll/IPayrollFunction';
import { IEmployeeFunctionLinkRow } from './types';

export const buildLinkRows = (
  links: IEmployeeFunctionLink[],
  employees: UPDropdownItem[],
  functions: IPayrollFunction[],
): IEmployeeFunctionLinkRow[] =>
  links
    .map(link => {
      const linkedFunctions = link.functionIds
        .map(id => functions.find(f => f.id === id))
        .filter(Boolean) as IPayrollFunction[];
      return {
        employeeId: link.employeeId,
        employeeName: employees.find(e => toNumber(e.value) === link.employeeId)?.label ?? '',
        functionIds: link.functionIds,
        functionsLabel: linkedFunctions.map(f => f.description).join(', '),
        categoriesLabel: linkedFunctions.map(f => f.category).join(', '),
      };
    })
    .sort((a, b) => a.employeeName.localeCompare(b.employeeName));
